export default __webpack_public_path__ + "static/media/ali.e64b0737.svg";